import { FaWhatsapp } from "react-icons/fa";
import { CLINIC_WHATSAPP } from "@/lib/clinic";

export default function WhatsAppFloat({ number = CLINIC_WHATSAPP }) {
  const msg = encodeURIComponent(
    "Hi Dr. Ashish, I'd like to book a consultation. Please share available slots."
  );
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={`https://wa.me/${number}?text=${msg}`}
      target="_blank"
      rel="noreferrer"
      className="pulse-ring fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-xl hover:scale-105 transition-transform"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp size={28} />
    </a>
  );
}
